import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  chip: {
    marginRight: 8,
    height: 24
  }
};

const PrismPushMenu = ({ classes, actionName, anchorEl, onClose, includedProperties, highlightedProperties, onSubmitIncluded, onSubmitHighlighted }) => {
  const onClickIncluded = () => {
    onClose();
    onSubmitIncluded();
  };

  const onClickHighlighted = () => {
    onClose();
    onSubmitHighlighted();
  };

  const renderItem = (text, properties, onClick) => (
    <MenuItem onClick={onClick} disabled={properties.length === 0}>
      <Chip className={classes.chip} label={properties.length} color="secondary"/>
      <Typography variant="inherit" display='inline'>
        {text}
      </Typography>

      {/* <Badge badgeContent={properties.length} color="secondary">
        <Typography variant="inherit">{text}</Typography>
      </Badge> */}
    </MenuItem>
  );
  return (
    <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={onClose}>
      {renderItem(`${actionName} Included`, includedProperties, onClickIncluded)}
      {renderItem(`${actionName} Highlighted`, highlightedProperties, onClickHighlighted)}
    </Menu>
  );
};

export default withStyles(styles)(PrismPushMenu);
